import {
  logoDT,
  logoCE,
  logoSelo,
  logoAT,
  logoGOV,
  logoTerritorio,
} from "./logosSistemas";
import titulos from "./titleSistema";

const branch = "inscricao";

/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  isIndicadores: false,
  isSala: false,
  isParceiro: false,
  isAT: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  {
    tag: "inscricao.sistemaselosebrae",
    banco: "selo-inscricao-2026",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_DEV,
  },
  {
    tag: "inscricoes.sistemaselosebrae",
    banco: "selo-inscricao-2026",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_DEV,
  },
  {
    tag: "inscricao.selosaladoempreendedor",
    banco: "selo-inscricao-2026",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_DEV,
  },
  {
    tag: "inscricao-dev.selosaladoempreendedor",
    banco: "selo-inscricao-2026",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_DEV,
  },
  {
    tag: "inscricao-dev.sistemaselosebrae",
    banco: "selo-inscricao-2026",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_DEV,
  },
  {
    tag: "inscricao-hlg.sistemaselosebrae",
    banco: "selo-inscricao-2026-dev",
    uf: "RJ",
    env: process.env.VUE_APP_BASE_API_INSCRICAO_HLG,
  },
  {
    tag: "localhost",
    banco: "selo-inscricao-2026-dev",
    uf: "SC",
    isSala: true,
  },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

export const EnumAmbienteTipos = {
  prod: "prod",
  dev: "dev",
  hlg: "hlg",
};

let atual;
let hrf = window.location.href;
const ceDevBanco = "ce-dev";
const ceHlgBanco = "ce-hlg";

ufsDefinitions.forEach((item) => {
  if (hrf.includes("sistemaselo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("selo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("agentesterritoriais")) {
    item.isAT = true;
  } else if (hrf.includes("governancaempreendedora")) {
    item.isGov = true;
  } else if (hrf.includes("desenvolvimentoterritorial")) {
    item.isDT = true;
  } else if (hrf.includes("territoriosempreendedores")) {
    item.isTerritorio = true;
  } else {
    item.isCE = true;
  }

  if (item.isSala || item.isParceiro) {
    if (!item.title) item.title = titulos.sala;
    if (!item.corPrimaria) item.corPrimaria = "#2a4fd7";
    if (!item.logos) item.logos = logoSelo;
  } else if (item.isAT) {
    if (!item.title) item.title = titulos.at;
    if (!item.logos) item.logos = logoAT;

    if (!item.corPrimaria) item.corPrimaria = "#93CE98";
    if (!item.logo) item.logo = "logo_at_branca.png";
  } else if (item.isGov) {
    if (!item.title) item.title = titulos.gov;
    if (!item.logos) item.logos = logoGOV;
    if (!item.logo) item.logo = "Logo_Governança_Empreendedora-branca.png";
    if (!item.corPrimaria) item.corPrimaria = "#9079A8";
  } else if (item.isDT) {
    if (!item.title) item.title = titulos.dt;
    if (!item.logos) {
      item.logos = logoDT;
    }
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else if (item.isTerritorio) {
    if (!item.title) item.title = titulos.territorio;
    if (!item.logos) {
      item.logos = logoTerritorio;
    }
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else {
    if (!item.logo) item.logo = "logo_nacional.png";
    if (!item.logos) item.logos = logoCE;
    if (!item.title) item.title = titulos.ce;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  }

  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (
      item.tag.indexOf("dev") !== -1 ||
      item.tag.indexOf("amazonaws.com") !== -1
    ) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO -----------------!"
      );

      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_DEV;
      item.ambient = EnumAmbienteTipos.dev;

      if (!item.banco) {
        item.banco = ceDevBanco;
      }
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE HOMOLOGAÇÃO -----------------!"
      );
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_HLG;
      item.ambient = EnumAmbienteTipos.hlg;

      if (!item.banco) {
        item.banco = ceHlgBanco;
      }
      // urls com localhost no nome
    } else if (item.tag.indexOf("localhost") !== -1) {
      if (!item.banco) {
        item.banco = ceDevBanco;
      }
      item.ambient = EnumAmbienteTipos.dev;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      console.log("!----------------- AMBIENTE DE PRODUÇÃO -----------------!");
      item.ambient = EnumAmbienteTipos.prod;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_PROD;
    }

    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      let indexOfArroba = str.indexOf("@", 0);
      let indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      let names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (typeof a === "string" && typeof b === "string") {
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return -1;
    }
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return 1;
    }
  } else {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
  }
  return 0;
};
